import React, { useEffect, useState } from "react";

const OfferFilters = ({ offerEndTime, openFilters, openAddOffer }) => {

    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {

        if (!offerEndTime) {
            setTimeLeft(0); // 🔥 force reset
            return;
        }

        const timer = setInterval(() => {

            const now = new Date().getTime();
            const end = new Date(offerEndTime).getTime();

            const diff = end - now;

            setTimeLeft(diff > 0 ? diff : 0);

        }, 1000);

        return () => clearInterval(timer);

    }, [offerEndTime]);

    const formatTime = () => {

        if (!timeLeft || timeLeft <= 0) return "00:00:00";

        const totalSeconds = Math.floor(timeLeft / 1000);

        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        return `${h}:${m}:${s}`;

    };

    return (

        <div className="card filter-card">

            <div className="filter-row">

                <button
                    className="filter-btn"
                    onClick={openFilters}
                >
                    Filters
                </button>

                <div className="offer-timer">

                    ⏰ {formatTime()}

                </div>

                <button className="btn-primary" onClick={openAddOffer}>
                    Add New Offer
                </button>

            </div>

        </div>

    );

};

export default OfferFilters;